import { render, staticRenderFns } from "./EdicionCiudades.vue?vue&type=template&id=2305c715&scoped=true"
import script from "./EdicionCiudades.vue?vue&type=script&lang=js"
export * from "./EdicionCiudades.vue?vue&type=script&lang=js"
import style0 from "./EdicionCiudades.vue?vue&type=style&index=0&id=2305c715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305c715",
  null
  
)

export default component.exports